import _defaults from 'lodash/defaults';

class CurrencyType {
    public PK: number;
    public Name: string;
    public Suffix: string;

    public constructor (params?: Partial<CurrencyType>) {
        _defaults(this, params);
    }
}

const defaultMoney: Partial<Money> = {
    CurrencyType: new CurrencyType(),
    Formatted: '',
    Value: 0
};

const defaultMoneyTotal: Partial<MoneyTotal> = {
    Count: 0,
    CurrencyType: new CurrencyType(),
    Formatted: '',
    Value: 0
};

class Money {
    public CurrencyType: CurrencyType;
    public Formatted: string;
    public Value: number;

    public constructor(params?: Partial<Money>) {
        _defaults(this, params, defaultMoney);
    }
}

class MoneyTotal {
    public Count: number;
    public CurrencyType: CurrencyType;
    public Formatted: string;
    public Value: number;

    public constructor(params?: Partial<Money>) {
        _defaults(this, params, defaultMoneyTotal);
    }
}

const defaultConvertedMoney: Partial<ConvertedMoney> = {
    Original: new Money(),
    Rate: 0,
    RateDate: '',
    IsConverted: false
};

class ConvertedMoney extends Money {
    public Original: Money;
    public Rate: number;
    public RateDate: string;
    public IsConverted: boolean;

    public constructor(params?: Partial<ConvertedMoney>) {
        super(params);
        _defaults(this, params, defaultConvertedMoney);
    }
}

export {
    CurrencyType,
    ConvertedMoney,
    Money,
    MoneyTotal
};
